import type { Middleware } from 'redux'

import { isSetReduxSliceAction } from '@app/packages/reduxSlice/reduxSlice'

/**
 * The types of the last actions dispatched, oldest first, a slice's with its key since every slice shares
 * one type. No payloads, so an error report can carry them: a loop through the store shows as one entry repeated.
 */
export class ActionTrail {
  private readonly size: number
  private readonly types: string[] = []

  constructor(size = 30) {
    this.size = size
  }

  // Recorded before the action runs, so the one a reducer or a subscriber throws on is in the trail too.
  readonly middleware: Middleware = () => next => action => {
    if (hasType(action)) {
      this.types.push(isSetReduxSliceAction(action) ? `${action.type}:${action.payload.key}` : action.type)
      if (this.types.length > this.size) this.types.shift()
    }
    return next(action)
  }

  read(): readonly string[] {
    return [...this.types]
  }
}

const hasType = (action: unknown): action is { type: string } =>
  typeof action === 'object' && action !== null && 'type' in action && typeof action.type === 'string'
